import { copy } from '~/_shared/utils/collections/collections';
import type { LimitNotificationsAction } from '~/store/frontendState/limitNotifications/limitNotifications.action';
import {
  limitNotificationsAddItem, limitNotificationsRemoveItem,
} from '~/store/frontendState/limitNotifications/limitNotifications.actionCreators';
import type { LimitNotificationsState } from './limitNotifications.state';

const initialState: LimitNotificationsState = {
  notifications: new Map(),
};

export const limitNotificationsReducer = (state: LimitNotificationsState = initialState, action: LimitNotificationsAction): LimitNotificationsState => {
  if (limitNotificationsAddItem.match(action)) {
    return {
      notifications: copy.andReplace(state.notifications, action.payload.notification.key, action.payload.notification),
    };
  }

  if (limitNotificationsRemoveItem.match(action)) {
    return {
      notifications: copy.andRemove(state.notifications, [action.payload.key]),
    };
  }

  return state;
};
